<!--
출고요청 기능 - 완료처리(출고대기)
------------------------------------

-->
<template>
   <div v-if="false">
   </div>
</template>

<script>
    export default {
        props: {
            /**
             * 일괄기능 공유data (상세정의는 컨트롤러 참고)
             */
            batch: Object,

            // csrf-token
            csrfToken: String,
            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },
        },
        data: function () {
            
            return {

                /**
                 * 작업대상 (작업상태 와 실제 작업대상이되는 아이템정보를 가진다.)
                 *  - 작업이 초기화될때, 작성된다.
                 * [
                 *  {state: 'success', job_msg: '작업관련 메세지(성공/실패)', item: {실제아이템정보}, next: {다음아이템포인터}},
                 *  {state: 'fail', ...},
                 *  {state: 'doing', ...},
                 *  {state: 'ready', ...},
                 * ]
                 */
                jobTargets: [],
            };
        },
        computed: {

        },
        methods: {
            // 작업초기화 (모달창이 띄워지는 순간 초기화작업)
            jobInit() {
                // 작업대상아이템 하우스ID 변수작성
                let url = '/regions/'+this.regionId+'/shipout-requests/worklist';
                let targets = _.forEach(this.batch.checked_items, item => {
                    url = $.app.url_add_query(url, 'house_ids[]='+item.house_id);
                });

                // 새창에서 작업내역 페이지 열기
                window.open(url, '_blank');
            },

        }
    }
</script>

<style lang="scss" scoped>
</style>